"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _food = require("@/api/order/food");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      visible: false,
      order: {}
    };
  },
  methods: {
    handleOpen: function () {
      var _handleOpen = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(order) {
        var _yield$findOne, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _food.findOne)(order.id);
            case 2:
              _yield$findOne = _context.sent;
              data = _yield$findOne.data;
              this.visible = true;
              this.order = (0, _objectSpread2.default)({}, data);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleOpen(_x) {
        return _handleOpen.apply(this, arguments);
      }
      return handleOpen;
    }(),
    calcSumPrice: function calcSumPrice(data) {
      var sum = data.reduce(function (prev, cur) {
        return prev + cur.amount * cur.finalPrice;
      }, 0);
      return sum;
    },
    calcProductItem: function calcProductItem(productItem) {
      var subTotal = 0;
      if (productItem.orderFoodVariationDetails.length) {
        subTotal = productItem.orderFoodVariationDetails.reduce(function (total, item) {
          return total + item.quantity * item.price;
        }, 0);
      } else {
        subTotal = productItem.foodVariations.reduce(function (total, item) {
          return total + item.price;
        }, 0);
      }
      return (productItem.finalPrice + subTotal) * productItem.amount;
    }
  }
};